import { Component } from '@angular/core';
import {
	PageTab1Directive,
	PageTab2Directive,
	PageTab3Directive,
	PageTabsLayout,
	PageTabsWidget
} from '@eforall/dashboard';
import { ToolbarWidget } from '../../../ui/widget';
import { FinanceAwardsPageService } from './finance-awards.page.service';
import { FinanceAwardsTab1Part } from './tabs/tab-1/finance-awards-tab-1.part';
import { FinanceAwardsTab2Part } from './tabs/tab-2/finance-awards-tab-2.part';
import { FinanceAwardsViewsPart } from './views/finance-awards-views.part';


@Component({
	selector: 'finance-awards-page',
	standalone: true,
	imports: [
		FinanceAwardsTab1Part, FinanceAwardsTab2Part, FinanceAwardsViewsPart,
		PageTab1Directive, PageTab2Directive, PageTab3Directive,
		ToolbarWidget,
		PageTabsWidget],
	templateUrl: './finance-awards.page.html',
})
export class FinanceAwardsPage {


	constructor(
		public pageService: FinanceAwardsPageService,
	) {
	}


	onLayoutChange(layout: PageTabsLayout) {
		this.pageService.changeLayout(layout);
	}

}